module.exports = __webpack_public_path__ + "ptc_nakagawa_R1.92688d40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_R1.jpg
// module id = 7SS5
// module chunks = 0